<template>
    <div class="container py-3 pr-2 mr-2">
        <h2 class=" text-center">PARTICULAR</h2>
        <hr class="mr-1 ml-1 ">
        <div class="d-flex flex-row  h-100 holder"  style="max-height: 90%; margin: 0px 50px; ">
            <div class="flex-1 mr-3 file-con" style="overflow:auto;" >
                <ul>
                    <li v-for="(result, i) in search_results.sort((x,y) => (x.isAccess === y.isAccess)? 0 : x.isAccess? -1 : 1 )" :key="i" :class="(result.isAccess == true ? '' : 'disabled')" style=" overflow:hidden; white-space: nowrap; text-overflow:ellipsis;">
                        <p>{{result.particular}}</p>
                        <a @click="(result.isAccess === true ? showPreview(result) : '')">{{result.file_name}}</a>
                        <small class="mr-3 d-block">{{result.date_uploaded}}</small>
                        <small class="">{{result.uploaded_by}}</small>
                    </li>
                </ul>
            </div>

            <div class="flex-1 rounded bg-light position-relative flex flex-column file-viewer" style="gap: 5px;" v-show="show">

                <button class="close position-absolute" style="top: 10px; left: 10px;" @click="hidePreview">&times;</button>
                <h6 class="text-center">{{ preview.type != 'link' ? preview.name : '' }}</h6>
                    <div id="pdf-viewer" style='width: 90%; height: 90%; margin: 0 auto; ' v-if="getType == 'pdf'"/>
                    <div v-if="getType == 'link'" class="w-100 h-100 d-flex justify-content-center align-items-center flex-column"  >
                        <h3>Click here to visit</h3>
                        <a :href="preview.name"  class="text-center"> <p style="overflow:hidden; white-space: nowrap; text-overflow:ellipsis; width:300px; color:black !important;"> {{ preview.name }}</p></a>
                    </div>
                    <div v-if="getType != 'link' && getType != 'pdf'" class="d-flex justify-content-center align-items-center" style="width: 100%; height: 95%" >
                            <img :src="getBinary" style="max-width: 90%; max-height: 100%" >
                    </div>
  
                <button class="btn" @click="downloadFile" v-if="getType != 'link'">
                    <svg xmlns="http://www.w3.org/2000/svg" style="width: 2em; height: 2em" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                    </svg>
                </button>
            </div>

        </div>
    </div>
  <!-- </section> -->
</template>

<script>
// import axios from 'axios';
import WebViewer from '@pdftron/webviewer'

export default {
    data() {
        return {
            search_results: [],
            show: false,
            preview: {
                name: '',
                binary: '',
                isImage: true,
                trans_no: '',
                type: ''
            },
            type : '',
            // on: false,
            // pdf : `<div id="pdf-viewer" style='width: 100%; height: 95%; margin: 0 auto; '/>`
        }
    },

    computed : {
        getBinary() {
            return (this.preview.hasOwnProperty.call(this.preview, 'binary') ? 'data:'+(this.preview.type == 'pdf' ? 'application/pdf' : 'image/png')+';base64,'+this.preview.binary : '');
        },
        getType() {
            return (this.preview.hasOwnProperty.call(this.preview, 'type') ? this.preview.type : '');
        },
    },
    methods: {
         convertPDF() {
            const binaryString = window.atob(this.preview.binary);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; ++i) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            return new Blob([bytes], { type: 'application/pdf' });
        },
        initPDF() {
            setTimeout(() => {
                const element = document.getElementById('pdf-viewer');
        
                WebViewer({
                path: `${process.env.BASE_URL}webviewer`, // point to where the files you copied are served from
                disabledElements: ['toolsHeader', 'ribbons'],
                fullAPI: true,
                }, element).then((instance) => {
                    const { docViewer } = instance;


                    instance.loadDocument(this.convertPDF(), { filename: `${this.preview.name}.pdf` });

                    docViewer.on('documentLoaded', () => {
                        console.log('loaded')
                        // console.log(this.preview.binary)
                    });
                })

            }, 200);

       
        },

        async showPreview(result) {
            // var link = '/preview?trans_no='+result.trans_no;
    //  this.type = '';
            this.preview.type = '';
            this.type = '';

            this.preview.name = result.file_name;
            this.preview.trans_no = result.trans_no;

            await this.$axios.get('/preview?trans_no='+result.trans_no)
                    .then(res => {
                        this.preview.name = res.data.name;

                        // if(res.data.type === 'link') this.preview.url = res.data.binary;
                        // else this.preview.url = 'data:'+res.data.mime_type+';base64,'+res.data.binary;
                        // else this.preview.binary = res.data.binary;

                        this.preview.binary = res.data.binary;
                            //  console.log(this.preview.binary)
                        // if(res.data.type !== 'pdf') this.preview.isImage = true;
                        // else this.preview.isImage = false;
                        
                        this.preview.type = res.data.type;
                        
                        this.type = res.data.type;
      
                        // this.initPDF()
                    })
                    .catch(() => {
                        return this.show = false;
                    });

            this.show = true;
        },
        hidePreview() {
            this.show = false;
            this.preview.name = '';
            this.preview.url = '';
            this.preview.type = '';
            this.type = '';

            // document.getElementById('pdf-viewer').reset()
            
                    //  const value = document.querySelector('#pdf-viewer');
                    // //  const attribute = element.getAttribute(value)
                    // value.remove();
                    // console.log(value)
               
        },
        async searchData() {
            var query = this.$route.query.common_number;
            await this.$axios.get(`/detail?common_number=${query}`)
                    .then(res => {
                        this.search_results = res.data;
                        // console.log(res.data)
                    })
                    .catch(err => {
                        console.error(err);
                    })
        },
        async downloadFile() {
            var trans_no = this.preview.trans_no;
            await this.$axios.get(`/download?file_id=${trans_no}`)
                .then(function(response){
                    var file = response.data;
                    var mime_type = file.mime_type;
                    var filename = file.name;

                    //FILE
                    if(mime_type != 'link') {
                        var binary = 'data:'+mime_type+';base64,'+file.binary;
                        const link = document.createElement('a');
                        link.href = binary;
                        link.setAttribute('download', filename); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                    }
                    //URL
                    else {
                        // window.location.href = filename;
                        window.open(filename);
                    }
                })
                .catch(err => {
                    this.$jlalert.show(err);
                });
        }
    },
    mounted() {
        if(this.$route.query.common_number === '') return this.$router.push('/searcher');
        this.searchData();
    },
    watch : {
        'type': function(n) {
            console.log(this.getType)
           if(n == 'pdf'){
            this.initPDF()
           }
        },
    }
}
</script>

<style scoped>

.container{
    max-width: unset;
    /* overflow: auto; */
    height: 95%;
    width: 100%;
}

.holder{
    justify-content: space-between;
}

/* width */
.file-con::-webkit-scrollbar {
  width: 10px;

}

/* Track */
.file-con::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
.file-con::-webkit-scrollbar-thumb {
  background: lightgrey; 
  border-radius: 10px;

}

/* Handle on hover */
.file-con::-webkit-scrollbar-thumb:hover {
  background: grey; 
}
img{
        filter: blur(1px);
        -webkit-filter: blur(1px);
}
ul {
    list-style-type: none;
    padding-left: 0;
}

ul li {
    margin-bottom: 18px;
}

ul li p {
    font-size: 20px;
    font-weight: 500;
}

ul li a, ul li p {
    margin-bottom: 0;
}

.disabled, .disabled a {
    opacity: 0.4;
    cursor: not-allowed;
}
/* li {
    text-overflow: ellipsis !important;
} */
h2,small,p,a{
    color: white !important;
}

</style>